/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import {
  Button,
  Grid,
  Group,
  Input,
  InputWrapper,
  Paper,
  Space,
  Switch,
  Text,
  Textarea,
  ThemeIcon,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconDeviceFloppy, IconNotes, IconScale, IconZoomMoney } from '@tabler/icons-react';
import { Tabs } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import BasicPriceTax, { BasicPriceTaxRef } from '../../../../components/BasicPriceTax';
import BasicPricing, { BasicPricingData, BasicPricingRef } from '../../../../components/BasicPricing';
import BasicValueUnits, {
  BasicValueUnitsData,
  BasicValueUnitsRef,
} from '../../../../components/BasicValueUnits';
import EntityItemPicker from '../../../../components/core/EntityItemPicker/EntityItemPicker';
import PageSection from '../../../../components/core/PageSection/PageSection';
import ToleranceForm from '../../../../components/core/Tolerance/ToleranceForm';
import { EntityTypeType, UnitOfMeasureType } from '../../../../models/core/cache.type';
import { Action } from '../../../../models/core/core.type';
import { EntitySearchResponseType } from '../../../../models/core/entities.type';
import {
  ProposalResiduePlanPricingType,
  ProposalResiduePlanQuotationVehicleType,
  ProposalResiduePlanVehicleType,
  ProposalTipoPrecificacaoEnum,
} from '../../../../models/core/proposals.type';
import { EntityItemEnum, Feature, Financial } from '../../../../utils/constants.utils';
import { buildFakeAuditObject, isNullOrEmpty, newGuid } from '../../../../utils/helper.utils';

type FormViewData = {
  action: Action;
  id: string;
  fornecedorData: EntitySearchResponseType | null;
  idFornecedor: number | null;
  fornecedor: string;
  idEntidadeResiduoVeiculo: number | null;
  cobrarSeCompartilhado: boolean | null;
  quantidade: number | null;
  quantidadeIdUnidadeMedida: string | null;
  frequenciaIdUnidadeMedida: string | null;
  minimoAceitavel: number | null;
  minimoAceitavelIdUnidadeMedida: string | null;
  preco: number | null;
  precificacao: BasicPricingData;
  observacao: string | null;
  quantidadeFrequencia: unknown;
};

type Props = {
  modoEdicao: boolean;
  requireSupplier?: boolean;
  referenceData: {
    entityTypeData?: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
  };
  origItem: ProposalResiduePlanQuotationVehicleType | null;
  item: ProposalResiduePlanQuotationVehicleType | null;
  refItem: ProposalResiduePlanVehicleType;
  idPropostaResiduoPlanoCotacao?: number;
  defaultActiveKey?: string;
  zIndex: number;
  hidePricingSection?: boolean;
  hideCustomerSection?: boolean;
  submitLabel?: string;
  callback?: (
    item: ProposalResiduePlanQuotationVehicleType | null,
    refItem: ProposalResiduePlanVehicleType | null,
    action: string,
    confirmed: boolean
  ) => void | Promise<void>;
};

export type ResidueQuotationVehicleFormRef = {
  submit(action?: string): Promise<boolean>;
};

const buildFornecedorDataFromItem = (
  item: ProposalResiduePlanQuotationVehicleType | null
): EntitySearchResponseType | null => {
  if (!item || !item.idFornecedor) {
    return null;
  }
  return {
    ...buildFakeAuditObject(),
    idEntidade: Number(item.idFornecedor),
    tipos: [],
    cnpj: item.fornecedorCNPJ || null,
    razaoSocial: item.fornecedorRazaoSocial || null,
    nomeFantasia: item.fornecedorNomeFantasia || null,
    incricaoEstadual: null,
    incricaoMunicipal: null,
    cpf: item.fornecedorCPF || null,
    nome: item.fornecedorNome || null,
    webSite: null,
    aceitaEncontroContas: false,
  };
};

const buildInitialCustomerPricing = (
  item: ProposalResiduePlanQuotationVehicleType | null,
  refItem: ProposalResiduePlanVehicleType
): BasicPricingData => ({
  tipoPrecificacao: ProposalTipoPrecificacaoEnum.Especifica,
  quantidade:
    item?.precificacao?.quantidade ??
    refItem.precificacao?.quantidade ??
    item?.quantidade ??
    refItem.quantidade ??
    1,
  quantidadeIdUnidadeMedida:
    item?.precificacao?.quantidadeIdUnidadeMedida?.toString() ||
    refItem.precificacao?.quantidadeIdUnidadeMedida?.toString() ||
    item?.quantidadeIdUnidadeMedida?.toString() ||
    refItem.quantidadeIdUnidadeMedida?.toString() ||
    null,
  frequenciaIdUnidadeMedida:
    item?.precificacao?.frequenciaIdUnidadeMedida?.toString() ||
    refItem.precificacao?.frequenciaIdUnidadeMedida?.toString() ||
    item?.frequenciaIdUnidadeMedida?.toString() ||
    null,
  preco: item?.precificacao?.preco ?? refItem.precificacao?.preco ?? 0,
  imposto: item?.precificacao?.imposto ?? refItem.precificacao?.imposto ?? Financial.Tax,
});

const buildInitialValues = (
  item: ProposalResiduePlanQuotationVehicleType | null,
  refItem: ProposalResiduePlanVehicleType
): FormViewData => ({
  action: item ? Action.Nothing : Action.Add,
  id:
    item?.id ||
    item?.idTemporaria ||
    item?.idPropostaResiduoPlanoCotacaoVeiculo?.toString() ||
    refItem?.id ||
    newGuid(),
  fornecedorData: buildFornecedorDataFromItem(item),
  idFornecedor: item?.idFornecedor || null,
  fornecedor: item?.fornecedorNomeFantasia || item?.fornecedorRazaoSocial || item?.fornecedorNome || '',
  idEntidadeResiduoVeiculo: item?.idEntidadeResiduoVeiculo || null,
  cobrarSeCompartilhado: item?.cobrarSeCompartilhado || false,
  quantidade: item?.quantidade || null,
  quantidadeIdUnidadeMedida:
    item?.quantidadeIdUnidadeMedida?.toString() ||
    // refItem.quantidadeIdUnidadeMedida?.toString() ||
    // refItem.precificacao?.quantidadeIdUnidadeMedida?.toString() ||
    null,
  frequenciaIdUnidadeMedida: item?.frequenciaIdUnidadeMedida?.toString() || null,
  minimoAceitavel: item?.minimoAceitavel || null,
  minimoAceitavelIdUnidadeMedida: item?.minimoAceitavelIdUnidadeMedida?.toString() || null,
  preco: item?.preco ?? null,
  precificacao: buildInitialCustomerPricing(item, refItem),
  observacao: item?.observacao || '',
  quantidadeFrequencia: null,
});

const buildPricingTypeFromQuotation = (
  pricingData: BasicPricingData,
  unitOfMeasures: UnitOfMeasureType[]
): ProposalResiduePlanPricingType => {
  const quantidadeIdUnidadeMedida = pricingData.quantidadeIdUnidadeMedida
    ? Number(pricingData.quantidadeIdUnidadeMedida)
    : null;
  const frequenciaIdUnidadeMedida = pricingData.frequenciaIdUnidadeMedida
    ? Number(pricingData.frequenciaIdUnidadeMedida)
    : null;

  return {
    tipo: ProposalTipoPrecificacaoEnum.Especifica,
    quantidade: pricingData.quantidade,
    quantidadeIdUnidadeMedida,
    quantidadeUnidadeMedida:
      unitOfMeasures.find((x) => x.idUnidadeMedida === quantidadeIdUnidadeMedida)?.unidadeMedida || null,
    quantidadeUnidadeMedidaSigla:
      unitOfMeasures.find((x) => x.idUnidadeMedida === quantidadeIdUnidadeMedida)?.unidadeMedidaSigla || null,
    frequenciaIdUnidadeMedida,
    frequenciaUnidadeMedida:
      unitOfMeasures.find((x) => x.idUnidadeMedida === frequenciaIdUnidadeMedida)?.unidadeMedida || null,
    frequenciaUnidadeMedidaSigla:
      unitOfMeasures.find((x) => x.idUnidadeMedida === frequenciaIdUnidadeMedida)?.unidadeMedidaSigla || null,
    preco: pricingData.preco,
    imposto: pricingData.imposto,
  };
};

const ResidueQuotationVehicleForm = forwardRef<ResidueQuotationVehicleFormRef, Props>((props, ref) => {
  const refToleranceForm = useRef<any>();
  const refQuantityFrequency = useRef<BasicValueUnitsRef>(null);
  const refMinimum = useRef<BasicValueUnitsRef>(null);
  const refSupplierPriceTax = useRef<BasicPriceTaxRef>(null);
  const refCustomerPricing = useRef<BasicPricingRef>(null);

  const form = useForm<FormViewData>({
    initialValues: buildInitialValues(props.item, props.refItem),
    validate: {
      idFornecedor: (value) => (props.requireSupplier && (!value || value <= 0) ? 'Campo obrigatório' : null),
    },
  });

  const itemKey =
    props.item?.id ||
    props.item?.idPropostaResiduoPlanoCotacaoVeiculo?.toString() ||
    props.item?.idTemporaria ||
    'new';
  const refItemKey =
    props.refItem?.id ||
    props.refItem?.idPropostaResiduoPlanoVeiculo?.toString() ||
    props.refItem?.idTemporaria ||
    props.refItem?.idResiduoVeiculo?.toString() ||
    'ref';

  useEffect(() => {
    form.setValues(buildInitialValues(props.item, props.refItem));
    form.resetDirty();
    form.clearErrors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemKey, refItemKey]);

  const quantityUnit1Options = props.referenceData.unitOfMeasures
    .filter(
      (x) =>
        x.tipo === 'Massa' || x.tipo === 'Volume' || (x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')
    )
    .map((x) => ({
      value: x.idUnidadeMedida.toString(),
      label: `${x.unidadeMedida} (${x.unidadeMedidaSigla})`,
      group: x.tipo,
    }));

  const frequencyUnitOptions = props.referenceData.unitOfMeasures
    .filter((x) => x.tipo === 'Outro' && x.unidadeMedidaSigla === 'col')
    .map((x) => ({
      value: x.idUnidadeMedida.toString(),
      label: `${x.unidadeMedida} (${x.unidadeMedidaSigla})`,
      group: x.tipo,
    }));

  const minimumUnit2Value = frequencyUnitOptions[0]?.value || null;

  const inheritedCustomerPricingData = useMemo<BasicPricingData>(
    () => buildInitialCustomerPricing(props.item, props.refItem),
    [props.item, props.refItem]
  );

  const isSupplierDefined = !!form.values.idFornecedor;

  const isModified = (
    quantityFrequencyData?: BasicValueUnitsData | null,
    minimumData?: BasicValueUnitsData | null,
    supplierPriceTaxData?: { preco: number | null; imposto: number | null } | null,
    customerPricingData?: BasicPricingData | null
  ) => {
    const origData = `${props.origItem?.idFornecedor || ''}|${
      props.origItem?.idEntidadeResiduoVeiculo || ''
    }|${props.origItem?.cobrarSeCompartilhado || ''}|${props.origItem?.quantidade || ''}|${
      props.origItem?.quantidadeIdUnidadeMedida || ''
    }|${props.origItem?.frequenciaIdUnidadeMedida || ''}|${Number(props.origItem?.minimoAceitavel) || ''}|${
      props.origItem?.minimoAceitavelIdUnidadeMedida || ''
    }|${Number(props.origItem?.preco) || ''}|${Number(props.origItem?.precificacao?.quantidade) || ''}|${
      props.origItem?.precificacao?.quantidadeIdUnidadeMedida || ''
    }|${props.origItem?.precificacao?.frequenciaIdUnidadeMedida || ''}|${
      Number(props.origItem?.precificacao?.preco) || ''
    }|${Number(props.origItem?.precificacao?.imposto) || ''}|${props.origItem?.observacao || ''}`;

    const formData = `${form.values.idFornecedor || ''}|${form.values.idEntidadeResiduoVeiculo || ''}|${
      form.values.cobrarSeCompartilhado || ''
    }|${quantityFrequencyData?.valor ?? ''}|${quantityFrequencyData?.idUnidade1 || ''}|${
      quantityFrequencyData?.idUnidade2 || ''
    }|${minimumData?.valor ?? ''}|${minimumData?.idUnidade1 || ''}|${supplierPriceTaxData?.preco ?? ''}|${
      customerPricingData?.quantidade ?? ''
    }|${customerPricingData?.quantidadeIdUnidadeMedida || ''}|${
      customerPricingData?.frequenciaIdUnidadeMedida || ''
    }|${customerPricingData?.preco ?? ''}|${customerPricingData?.imposto ?? ''}|${
      form.values.observacao || ''
    }`;

    return origData !== formData;
  };

  const clearFornecedorData = () => {
    form.setFieldValue('fornecedorData', null);
    form.setFieldValue('idFornecedor', undefined as never as null);
    form.setFieldValue('fornecedor', '');
    form.setFieldValue('preco', '' as never as null);
    form.setFieldValue('quantidade', null);
    form.setFieldValue('frequenciaIdUnidadeMedida', null);
    form.setFieldValue('cobrarSeCompartilhado', false);
    form.setFieldValue('minimoAceitavel', undefined as never as null);
    form.setFieldValue('minimoAceitavelIdUnidadeMedida', undefined as never as null);
    refQuantityFrequency.current?.clear();
    refSupplierPriceTax.current?.clear();
    refMinimum.current?.clear();
  };

  const handleSubmit = async (action = 'callback'): Promise<boolean> => {
    const formValidation = form.validate();
    const quantityFrequencyData = !isSupplierDefined
      ? { valor: null, idUnidade1: null, idUnidade2: null }
      : refQuantityFrequency.current?.validate();
    const minimumData = !isSupplierDefined
      ? { valor: null, idUnidade1: null, idUnidade2: minimumUnit2Value }
      : refMinimum.current?.validate();
    const supplierPriceTaxData = !isSupplierDefined
      ? { preco: null, imposto: null }
      : refSupplierPriceTax.current?.validate();
    const customerPricingData = props.hideCustomerSection
      ? inheritedCustomerPricingData
      : refCustomerPricing.current?.validate();

    if (
      formValidation.hasErrors ||
      !quantityFrequencyData ||
      !minimumData ||
      !supplierPriceTaxData ||
      !customerPricingData
    ) {
      return false;
    }

    if (
      !isNullOrEmpty(supplierPriceTaxData.preco) &&
      isNullOrEmpty(quantityFrequencyData.valor) &&
      isNullOrEmpty(quantityFrequencyData.idUnidade2)
    ) {
      form.setFieldError(
        'quantidadeFrequencia',
        <Text size="xs" mt={5}>
          Campo obrigatório quando o preço é informado.
        </Text>
      );
      return false;
    }

    let values = { ...form.values };
    let nextAction = values.action;
    if (props.origItem) {
      if (
        isModified(quantityFrequencyData, minimumData, supplierPriceTaxData, customerPricingData) &&
        props.origItem.idPropostaResiduoPlanoCotacaoVeiculo
      ) {
        nextAction = Action.Modify;
      } else {
        values = {
          ...props.origItem,
          ...values,
          action: props.item?.action || Action.Nothing,
          quantidadeIdUnidadeMedida: quantityFrequencyData.idUnidade1 || '',
          frequenciaIdUnidadeMedida: quantityFrequencyData.idUnidade2 || '',
          minimoAceitavelIdUnidadeMedida: minimumData.idUnidade1 || '',
        };
        nextAction = values.action;
      }
    }

    const formItem: ProposalResiduePlanQuotationVehicleType = {
      ...buildFakeAuditObject(),
      ...(props.origItem || {}),
      ...values,
      action: nextAction,
      id: values.id,
      idTemporaria: props.origItem?.idTemporaria || values.id,
      idPropostaResiduoPlanoCotacao:
        props.idPropostaResiduoPlanoCotacao || props.origItem?.idPropostaResiduoPlanoCotacao || -1,
      quantidade: quantityFrequencyData.valor === null ? null : Number(quantityFrequencyData.valor),
      quantidadeIdUnidadeMedida: quantityFrequencyData.idUnidade1
        ? Number(quantityFrequencyData.idUnidade1)
        : null,
      frequenciaIdUnidadeMedida: quantityFrequencyData.idUnidade2
        ? Number(quantityFrequencyData.idUnidade2)
        : null,
      minimoAceitavel: minimumData.valor === null ? null : Number(minimumData.valor),
      minimoAceitavelIdUnidadeMedida: minimumData.idUnidade1 ? Number(minimumData.idUnidade1) : null,
      preco: supplierPriceTaxData.preco,
      precificacao: buildPricingTypeFromQuotation(customerPricingData, props.referenceData.unitOfMeasures),
    };

    formItem.quantidadeUnidadeMedida =
      formItem.quantidadeIdUnidadeMedida === null
        ? undefined
        : props.referenceData.unitOfMeasures.find(
            (x) => x.idUnidadeMedida === Number(quantityFrequencyData.idUnidade1)
          )?.unidadeMedida || '';

    formItem.frequenciaUnidadeMedida =
      formItem.frequenciaIdUnidadeMedida === null
        ? undefined
        : props.referenceData.unitOfMeasures.find(
            (x) => x.idUnidadeMedida === Number(quantityFrequencyData.idUnidade2)
          )?.unidadeMedida || '';

    formItem.minimoAceitavelUnidadeMedida =
      formItem.minimoAceitavelIdUnidadeMedida === null
        ? null
        : props.referenceData.unitOfMeasures.find((x) => x.idUnidadeMedida === Number(minimumData.idUnidade1))
            ?.unidadeMedida || null;

    formItem.minimoAceitavelUnidadeMedidaSigla =
      formItem.minimoAceitavelIdUnidadeMedida === null
        ? null
        : props.referenceData.unitOfMeasures.find((x) => x.idUnidadeMedida === Number(minimumData.idUnidade1))
            ?.unidadeMedidaSigla || null;

    formItem.preco = formItem.preco === null ? null : Number(formItem.preco);
    formItem.idFornecedor =
      form.values.fornecedorData?.idEntidade || form.values.idFornecedor
        ? Number(form.values.fornecedorData?.idEntidade || form.values.idFornecedor)
        : null;
    formItem.fornecedorCNPJ = form.values.fornecedorData?.cnpj || props.item?.fornecedorCNPJ || null;
    formItem.fornecedorRazaoSocial =
      form.values.fornecedorData?.razaoSocial || props.item?.fornecedorRazaoSocial || null;
    formItem.fornecedorNomeFantasia =
      form.values.fornecedorData?.nomeFantasia || props.item?.fornecedorNomeFantasia || null;
    formItem.fornecedorCPF = form.values.fornecedorData?.cpf || props.item?.fornecedorCPF || null;
    formItem.fornecedorNome = form.values.fornecedorData?.nome || props.item?.fornecedorNome || null;
    formItem.idPropostaResiduoPlanoVeiculo =
      props.refItem?.idPropostaResiduoPlanoVeiculo || props.origItem?.idPropostaResiduoPlanoVeiculo;
    formItem.idResiduoVeiculo = props.refItem?.idResiduoVeiculo || -1;
    formItem.residuoVeiculo = props.refItem?.residuoVeiculo || '';
    formItem.residuoVeiculoDescricao = props.refItem?.residuoVeiculoDescricao || null;
    formItem.observacao = formItem.observacao?.trim() || null;
    formItem.tolerancias = refToleranceForm.current?.validate() || props.item?.tolerancias || [];

    if (!isSupplierDefined) {
      formItem.idFornecedor = null;
      formItem.fornecedorCNPJ = null;
      formItem.fornecedorRazaoSocial = null;
      formItem.fornecedorNomeFantasia = null;
      formItem.fornecedorCPF = null;
      formItem.fornecedorNome = null;
      formItem.idEntidadeResiduoVeiculo = null;
      formItem.quantidade = null;
      formItem.quantidadeIdUnidadeMedida = null;
      formItem.frequenciaIdUnidadeMedida = null;
      formItem.preco = null;
      formItem.cobrarSeCompartilhado = false;
      formItem.minimoAceitavel = null;
      formItem.minimoAceitavelIdUnidadeMedida = null;
      formItem.minimoAceitavelUnidadeMedida = null;
      formItem.minimoAceitavelUnidadeMedidaSigla = null;
    }

    (formItem as any).refItem = props.refItem;
    await props.callback?.(formItem, props.refItem, action, true);
    return true;
  };

  useImperativeHandle(ref, () => ({
    submit(action = 'callback') {
      return handleSubmit(action);
    },
  }));

  const tabs = [
    {
      key: 'Cotacao',
      forceRender: true,
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconZoomMoney size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Cotação
          </Text>
        </Group>
      ),
      children: (
        <>
          {!props.hideCustomerSection && (
            <>
              <Grid columns={4}>
                <Grid.Col span={4}>
                  <Paper shadow="xs" p="md" withBorder>
                    <PageSection
                      size="md"
                      color={Feature.Home.Proposal.color}
                      label="Cliente"
                      text="Informações operacionais da cotação com o cliente."
                    />
                    <Space h="xs" />
                    <BasicPricing
                      ref={refCustomerPricing}
                      isEdit={props.modoEdicao}
                      disabled={!props.modoEdicao}
                      hideTipoPrecificacaoSelector
                      forcePricingActive
                      withFrequency
                      frequencyUnitDisabled
                      value={{
                        ...form.values.precificacao,
                        frequenciaIdUnidadeMedida:
                          form.values.precificacao.frequenciaIdUnidadeMedida ||
                          frequencyUnitOptions[0]?.value ||
                          null,
                        tipoPrecificacao: ProposalTipoPrecificacaoEnum.Especifica,
                      }}
                      onChange={(pricingData) => {
                        form.setFieldValue('precificacao', pricingData);
                      }}
                      quantityUnitOptions={quantityUnit1Options}
                      frequencyUnitOptions={frequencyUnitOptions}
                      zIndex={props.zIndex + 1}
                    />
                  </Paper>
                </Grid.Col>
              </Grid>
              <Space h="md" />
            </>
          )}

          <Paper shadow="xs" p="md" withBorder>
            <Group justify="space-between">
              <PageSection
                size="md"
                color={Feature.Home.Proposal.color}
                label="Fornecedor"
                text="Informações operacionais da cotação com o fornecedor."
              />
              {isSupplierDefined && (
                <Button size="xs" color="orange" onClick={clearFornecedorData} disabled={!props.modoEdicao}>
                  Limpar
                </Button>
              )}
            </Group>
            <Space h="xs" />
            <Grid columns={7}>
              <Grid.Col span={7}>
                <EntityItemPicker
                  label="Fornecedor"
                  item={EntityItemEnum.Vehicle}
                  itemId={props.refItem?.idResiduoVeiculo || -1}
                  formItem={form.getInputProps('idFornecedor') || undefined}
                  idsToBeDisabled={[]}
                  callback={async (item: EntitySearchResponseType | null) => {
                    if (item) {
                      form.setFieldValue('fornecedorData', item);
                      form.setFieldValue('idFornecedor', item.idEntidade);
                      form.setFieldValue(
                        'fornecedor',
                        item.nomeFantasia || item.razaoSocial || item.nome || ''
                      );
                      form.setFieldValue('idEntidadeResiduoVeiculo', (item as any).idEntidadeResiduoVeiculo);
                    }
                  }}
                  required={!!props.requireSupplier}
                  disabled={!props.modoEdicao}
                  zIndex={props.zIndex + 1}
                />
              </Grid.Col>

              {isSupplierDefined && (
                <>
                  <Grid.Col span={4}>
                    <InputWrapper {...form.getInputProps('quantidadeFrequencia')}>
                      <BasicValueUnits
                        ref={refQuantityFrequency}
                        isEdit={props.modoEdicao}
                        disabled={!props.modoEdicao || !isSupplierDefined}
                        disableUnit2
                        zIndex={props.zIndex + 1}
                        label="Quantidade/Frequência"
                        validationMode="all-or-none"
                        valueMin={1}
                        valueStep={1}
                        value={{
                          valor: form.values.quantidade,
                          idUnidade1: form.values.quantidadeIdUnidadeMedida,
                          idUnidade2:
                            form.values.frequenciaIdUnidadeMedida || frequencyUnitOptions[0]?.value || null,
                        }}
                        onChange={(quantityData) => {
                          form.setFieldValue('quantidade', quantityData.valor);
                          form.setFieldValue('quantidadeIdUnidadeMedida', quantityData.idUnidade1);
                          form.setFieldValue('frequenciaIdUnidadeMedida', quantityData.idUnidade2);
                        }}
                        unit1Options={quantityUnit1Options}
                        unit2Options={frequencyUnitOptions}
                      />
                    </InputWrapper>
                  </Grid.Col>
                  <Grid.Col span={1}>
                    <BasicPriceTax
                      ref={refSupplierPriceTax}
                      isEdit={props.modoEdicao}
                      disabled={!props.modoEdicao || !isSupplierDefined}
                      requiredPrice={
                        !isNullOrEmpty(form.values.quantidade) &&
                        !isNullOrEmpty(form.values.frequenciaIdUnidadeMedida)
                      }
                      showTax={false}
                      labelPreco="Preço"
                      value={{
                        preco: form.values.preco,
                        imposto: null,
                      }}
                      zIndex={props.zIndex + 1}
                    />
                  </Grid.Col>
                  <Grid.Col span={2}>
                    <div>
                      <Input.Wrapper label="Cobrar se compartilhado?">
                        <div style={{ marginBottom: 8 }} />
                      </Input.Wrapper>
                      <Switch
                        disabled={!props.modoEdicao || !isSupplierDefined}
                        {...form.getInputProps('cobrarSeCompartilhado', { type: 'checkbox' })}
                      />
                    </div>
                  </Grid.Col>
                  <Grid.Col span={7}>
                    <BasicValueUnits
                      ref={refMinimum}
                      isEdit={props.modoEdicao}
                      disabled={!props.modoEdicao || !isSupplierDefined}
                      disableUnit2
                      zIndex={props.zIndex + 1}
                      label="Mínimo Aceitável"
                      validationMode="all-or-none"
                      value={{
                        valor: form.values.minimoAceitavel,
                        idUnidade1: form.values.minimoAceitavelIdUnidadeMedida,
                        idUnidade2: minimumUnit2Value,
                      }}
                      onChange={(minimumData) => {
                        form.setFieldValue('minimoAceitavel', minimumData.valor);
                        form.setFieldValue('minimoAceitavelIdUnidadeMedida', minimumData.idUnidade1);
                      }}
                      unit1Options={quantityUnit1Options}
                      unit2Options={frequencyUnitOptions}
                    />
                  </Grid.Col>
                </>
              )}

              <Grid.Col span={7}>
                <Textarea
                  leftSection={<IconNotes size={15} />}
                  label="Observação"
                  placeholder="Observação sobre a cotação do veículo"
                  autosize
                  maxLength={500}
                  disabled={!props.modoEdicao}
                  {...form.getInputProps('observacao')}
                />
              </Grid.Col>
            </Grid>
          </Paper>
        </>
      ),
    },
    {
      key: 'Tolerancias',
      forceRender: true,
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconScale size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Tolerâncias
          </Text>
        </Group>
      ),
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <ToleranceForm
            ref={refToleranceForm}
            refId={props.item?.idPropostaResiduoPlanoCotacaoVeiculo}
            title="Tolerâncias"
            description="Tolerâncias para esta cotação."
            color={Feature.Home.Proposal.color}
            disabled={!props.modoEdicao}
            origData={props.origItem?.tolerancias || []}
            data={props.item?.tolerancias || []}
            referenceData={props.referenceData}
            zIndex={props.zIndex + 1}
          />
        </Paper>
      ),
    },
  ];

  return (
    <Paper shadow="xs" p="md" withBorder>
      <Tabs items={tabs} defaultActiveKey={props.defaultActiveKey || 'Cotacao'} />
      <Space h="md" />
      {props.modoEdicao && (
        <Group justify="right">
          <Button
            leftSection={<IconDeviceFloppy size={18} />}
            onClick={() => {
              handleSubmit();
            }}
          >
            {props.submitLabel || 'Salvar cotação'}
          </Button>
        </Group>
      )}
    </Paper>
  );
});

export default ResidueQuotationVehicleForm;
